<template>
    <div>
        <a-result v-if="content == ''" title="空文档">
            <template #extra>
                <a-button key="console" type="primary" @click="handleNew('adddoc')">
                    前往编辑
                </a-button>
            </template>
        </a-result>
        <div v-else>
            <a-button key="console" class="editDocBtn" type="primary" @click="handleNew('editdoc')">
                    编辑
            </a-button>
            <div class="docvieBox" v-html="content">
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            content:'',
            menucode:''
        };
    },
    methods: {
        handleNew(type){
            this.$router.push({
                path: type,
                query: {
                    id:'',
                }
            });
        },
        getContent(menuItem){
            let that = this
            that.menucode = menuItem.cMenucode;
            let params = {
                menucode:that.menucode,
                urlparams:false
            };
            that.$store.dispatch({
                type: "open/selectdoclist",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    if(result.length > 0){
                        this.content = res.data.data[0].body
                    }
                    else{
                        this.content = '';
                    }
                }
            }).catch(() => {
                this.message.error('未查询到文档');
            });
        },
 
    },

    components:{
    },
    mounted(){
    },

};
</script>
<style scoped>
   
    .tableLink{
        margin-right: 10px;
    }

    .editDocBtn{
        position: absolute;
        right: 0;
        top: 10px;
    }

    .docvieBox{
        width:100%;
        height: auto;
        margin-top: 28px;
        padding: 0 20px;
    }

</style>

